import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import { Section } from '@/blocks/components/layout';
import background from '@/styles/background.module.scss';
import context from '@/styles/contexts.module.scss';

import styles from './styles.module.scss';

type SectionsGroupProps = SectionsGroupBlockProps & {
  marginType?: 'padding' | 'margin' | false;
};

export function SectionsGroup(props: SectionsGroupProps) {
  const { marginType = 'padding', children, ...rest } = props;

  return (
    <Section tag={'div'} marginType={marginType}>
      <SectionsGroupBlock {...rest}>{children}</SectionsGroupBlock>
    </Section>
  );
}

type SectionsGroupBlockProps = ComponentPropsWithoutRef<'div'> & {
  gap?: boolean;
};

export function SectionsGroupBlock(props: SectionsGroupBlockProps) {
  const { className, children, gap = true, ...rest } = props;

  return (
    <div
      className={classNames(
        styles.sectionsGroup,
        background.geometryBgLight,
        context.light,
        { [styles.gap]: gap },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
